import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../../utils/constants';

const cancelOrder = (shipperZip, orderNumber) => {
  const formValueToApi = {
    orderId: Number(orderNumber),
    zone: shipperZip,
  };

  return axios.post(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.cancel}`, formValueToApi)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        return {
          title: t('CancelSuccessMessage'),
          closeLabel: t('Close'),
        };
      }

      return undefined;
    }).catch(() => ({
      title: t('CancelShipmentWarning'),
      description: t('CancelErrorMessage'),
      closeLabel: t('Close'),
    }));
};

export default cancelOrder;
